<template>
    <div class="mt-3 tabs-licenses">

        <div class="tabs-licenses-header">
            <span
                @click="setTabActive('license-history')"
                :class="tabActive === 'license-history' ? 'tabs-licenses-tab active' : 'tabs-licenses-tab'"
            >
                Historial de licencias
                <span class="badge badge-primary small ml-2">{{ licencias.data.length }}</span>
            </span>
            <span
                @click="setTabActive('Licensing-contract')"
                :class="tabActive === 'Licensing-contract' ? 'tabs-licenses-tab active' : 'tabs-licenses-tab'"
            >Contrato de licenciamiento</span>
        </div>

        <!-- tab 1 - datos de las licencias -->
        <div class="tabs-licenses-items" v-if="tabActive === 'license-history'">
            <!-- filtro -->
            <b-row>
                <b-col sm="6">
                    <b-form-group>
                        <b-input-group>
                            <b-form-input name="nombre" type="text" placeholder="Buscar..." v-model="filtros.busqueda"
                                @keypress.enter="obtenerLicencias" />
                            <b-input-group-append>
                                <b-button variant="primary" @click.prevent="obtenerLicencias">
                                    <i class="fa fa-search fa-lg" />
                                    <span class="d-none d-md-inline-block">Buscar</span>
                                </b-button>
                                <b-button @click="resetFiltros(); obtenerLicencias()">
                                    <i class="fa fa-eraser fa-lg" />
                                    <span class="d-none d-md-inline-block"> Limpiar</span>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>

                    </b-form-group>
                </b-col>

                <b-col sm="6" v-if="validarPermisoComponente('empresa-editar-licencias')">
                    <b-button variant="primary" class="float-right" @click="_crearLicencia">
                        Nuevo
                    </b-button>
                </b-col>
            </b-row>

            <!-- tabla de historico -->
            <b-table responsive striped hover :items="licencias.data" :fields="columnas"
                empty-text="No hay licencias para mostrar" show-empty thead-tr-class="table-active">
                <!-- Fecha inicio -->
                <template v-slot:cell(fecha_inicio)="data">
                    {{ data.item.fecha_inicio.slice(0, 10) }}
                </template>

                <!-- Fecha fin -->
                <template v-slot:cell(fecha_fin)="data">
                    {{ data.item.fecha_fin.slice(0, 10) }}
                </template>

                <!-- Estado -->
                <template v-slot:cell(activo)="data">
                    <b-badge v-if="data.item.activo" variant="primary" v-text="'Activo'" />
                    <b-badge v-else variant="danger" v-text="'Inactivo'" />
                </template>

                <!-- Vigencia -->
                <template v-slot:cell(vigencia)="data">
                    <b-badge v-if="data.item.vigencia === 'Vigente'" variant="success" v-text="'Vigente'" />
                    <b-badge v-else-if="data.item.vigencia === 'Pendiente'" variant="info" v-text="'Pendiente'" />
                    <b-badge v-else-if="data.item.vigencia === 'Vencida'" variant="warning" v-text="'Vencida'" />
                </template>

                <!-- Acciones -->
                <template v-slot:cell(acciones)="data" v-if="validarPermisoComponente('empresa-editar-licencias')">
                    <el-tooltip content="Editar licencia" placement="top" effect="dark" size="small">
                        <i class="fa fa-edit fa-lg text-info mx-1" @click="_editarLicencia(data.item.id)" />
                    </el-tooltip>

                    <el-tooltip v-if="!!data.item.activo" content="Inactivar" placement="top" effect="dark" size="small">
                        <i class="fa fa-close fa-lg text-danger mx-1" @click="cambiarEstado(data.item.id)" />
                    </el-tooltip>

                    <el-tooltip v-else content="Activar" placement="top" effect="dark" size="small">
                        <i class="fa fa-check fa-lg text-success mx-1" @click="cambiarEstado(data.item.id)" />
                    </el-tooltip>

                </template>
            </b-table>

            <!-- paginacion -->
            <b-row>
                <b-col>
                    <b-button @click="backRoute()" size="sm" variant="secondary" class="float-left">
                        <i class="fa fa-reply fa-lg"></i>
                        Volver
                    </b-button>

                    <!-- Paginación -->
                    <el-pagination v-if="licencias.data && !!licencias.data.length" v-model="filtros.page"
                        @size-change="obtenerLicencias" @current-change="obtenerLicencias" :current-page.sync="filtros.page"
                        class="float-right" :page-size.sync="filtros.cantidad" :page-sizes="[10, 30, 50, 100]"
                        layout="total, sizes, prev, pager, next" :total="licencias.total" />
                </b-col>
            </b-row>

            <!-- formulario -->
            <formulario :responsibles="responsibles" />
        </div>

        <!-- tab 2 - detalles del contrato -->
        <div class="tabs-licenses-items" v-else-if="tabActive === 'Licensing-contract'">
            <!-- TExto contrato -->
          <b-card style="border: none"  header-tag="header" header-class="font-weight-bold" no-body>
            <quill-editor v-model="company.licensing_contract"/>
          </b-card>
            <br />
            <b-row>
                <b-col>
                    <!-- regresar -->
                    <b-button sm="12" md="6" @click="backRoute()" variant="secondary" class="float-left">
                        <i class="fa fa-reply fa-lg mr-1"></i>
                        Volver
                    </b-button>

                    <!-- Guardar cambios -->
                    <b-button v-if="validarPermisoComponente('empresa-editar-licencias')" sm="12" md="6" variant="primary" class="float-right" @click="storeTextLicensingContract()">
                        <i class="fa fa-save fa-lg mr-1"></i>
                        Guardar cambios
                    </b-button>
                </b-col>
            </b-row>
        </div>

    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import formulario from './formulario';
import Swal from 'sweetalert2';
import QuillEditor from "@/shared/components/QuillEditor.vue";
import { validarPermisoComponente } from "@/plugins/acl";
export default {
    name: 'index',
    props: ['company'],
    components: {
        formulario,
        QuillEditor
    },
    data() {
        return {
            validarPermisoComponente: validarPermisoComponente,
        };
    },
    computed: {
        ...mapState('licencias', [
            'licencias',
            'licencia',
            'filtros',
            'responsibles',
            'licensingContract',
            'tabActive'
        ]),
        columnas() {
            const columnasBase = [
                {
                    key: 'codigo',
                    label: 'Código', sortable: false,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'fecha_inicio',
                    label: 'Fecha inicio', sortable: false,
                    tdClass: 'text-center text-nowrap',
                    thClass: 'text-center'
                },
                {
                    key: 'fecha_fin',
                    label: 'Fecha fin', sortable: false,
                    tdClass: 'text-center text-nowrap',
                    thClass: 'text-center'
                },
                {
                    key: 'cantidad_usuarios',
                    label: 'Usuarios', sortable: false,
                    tdClass: 'text-center text-nowrap',
                    thClass: 'text-center'
                },
                {
                    key: 'productos_pendientes',
                    label: 'Productos disponibles', sortable: false,
                    tdClass: 'text-center text-nowrap',
                    thClass: 'text-center'
                },
                {
                    key: 'duracion',
                    label: 'Duración', sortable: false,
                    tdClass: 'text-center',
                    thClass: 'text-center'
                },
                {
                    key: 'dias_restantes',
                    label: 'Días restantes', sortable: false,
                    tdClass: 'text-center',
                    thClass: 'text-center'
                },
                {
                    key: 'vigencia',
                    label: 'Vigencia', sortable: false,
                    tdClass: 'text-center',
                    thClass: 'text-center'
                },
                {
                    key: 'cantidad_horas',
                    label: 'Hrs ejecutadas', sortable: false,
                    tdClass: 'text-center',
                    thClass: 'text-center'
                },
                {
                    key: 'activo',
                    label: 'Estado', sortable: false,
                    tdClass: 'text-center',
                    thClass: 'text-center'
                },
            ];

            if (this.validarPermisoComponente('empresa-editar-licencias')) {
                columnasBase.push({
                    key: 'acciones',
                    label: 'Acciones',
                    sortable: false,
                    tdClass: 'text-center',
                    thClass: 'text-center'
                });
            }

            return columnasBase;
        },
    },
    async mounted() {
        await this.obtenerLicencias();
        await this.obtenerModalidadesDePago();
    },
    methods: {
        ...mapActions('licencias', [
            'obtenerLicencias',
            'obtenerLicencia',
            'cambiarEstado',
            'obtenerModalidadesDePago',
            'storeLicensingContract',
        ]),
        ...mapMutations('licencias', [
            'establecerModalVer',
            'establecerAccion',
            'resetFiltros',
            'resetLicencia',
            'establecerLicencias',
            'setResponsibles',
            'setTabActive'
        ]),
        ...mapMutations('empresas', [
            'setDatosEmpresa',
        ]),
        // Pagos mensuales de la licencias.
        ...mapMutations('monthlyPayments', [
            'setMonthlyPayments',
            'setActivedTabMonthlyPayment'
        ]),
        async _crearLicencia() {

            // Limpiar los datos de pagos de la licencia
            this.resetContentMonthlyPayments();

            this.responsibles = [];
            this.resetLicencia();
            this.establecerAccion('Crear');
            this.establecerModalVer(true);
        },
        async _editarLicencia(id) {

            // Limpiar los datos de pagos de la licencia
            this.resetContentMonthlyPayments();

            await this.obtenerLicencia(id);
            this.setResponsibles([]);
            if (this.licencia.responsible != null) this.responsibles.push(this.licencia.responsible);
            this.establecerAccion('Actualizar');
            this.establecerModalVer(true);
        },
        // Limpiar los datos de pagos de la licencia
        resetContentMonthlyPayments() {
            this.setMonthlyPayments([]);
            this.setActivedTabMonthlyPayment(1);
        },
        handleInputLicensingContract(value) {
            this.setDatosEmpresa(value);
        },
        handleErrorLicensingContract() {
            Swal.fire({
                position: 'center',
                icon: 'info',
                title: "Ocurrio un error al tratar de procesar el texto ingresado.",
                showConfirmButton: true
            });
        },
        async storeTextLicensingContract() {
            await this.storeLicensingContract(this.company);
        },
        backRoute(){
            const currentPath = this.$route.path;
            if (currentPath.includes("/my-company")) {
                this.$router.go(-1);
            }else {
                this.$router.push("/empresas");
            }
        }
    }
};
</script>

<style scoped>
.tabs-licenses {
    border: 0px !important;
}
.tabs-licenses-header{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}
.tabs-licenses-tab{
    border-radius: 6px;
    padding: 7px 12px;
}
.tabs-licenses-tab:hover {
    cursor: pointer;
}
.tabs-licenses-tab.active {
    cursor: pointer;
    border: 1px solid #f0f3f5;
    background-color: #f0f3f5;
    font-weight: bold;
}
.tabs-licenses-items{
    margin-top: 20px;
    min-width: 190px;
}
@media only screen and (max-width: 767px) {
    .tabs-licenses-tab {
        width: 100%;
        text-align: center;
    }
}
</style>
